import { render, staticRenderFns } from "./insTypeResult.vue?vue&type=template&id=8690bf28"
import script from "./insTypeResult.vue?vue&type=script&lang=js"
export * from "./insTypeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports